export enum AttachmentType {
  PDF = 'pdf',
  IMAGE = 'image',
  YOUTUBE = 'youtube'
}

export enum AttachmentStatus {
  PENDING = 'pending',
  UPLOADING = 'uploading',
  PROCESSING = 'processing',
  COMPLETE = 'complete',
  ERROR = 'error'
}

export interface Attachment {
  id: string;
  type: AttachmentType;
  name: string;
  mimeType?: string;
  file?: File;
  files?: File[]; // For multiple images grouped together
  url?: string;
  thumbnail?: string;
  thumbnails?: string[]; // For multiple image thumbnails
  videoId?: string;
  
  // Processing status
  status?: AttachmentStatus;
  progress?: number;
  error?: string;
  
  extractedText?: string;
  summary?: string;

  attachmentId?: string;

  // Backend IDs after upload
  documentId?: string; // For PDFs and images (converted to PDF)
  videoDbId?: string; // For YouTube videos
}
